<template>
    <div>
        <full-calendar
            ref="calendar"
            :events="events"
            :config="config"
            @day-click="click"
            @event-drop="drop"
            @event-selected="edit"
            @event-resize="drop"
            @view-render="refresh"
        ></full-calendar>
        <modal
            init_id="CalendarModal"
            :init_fields="{}"
            :init_title="''"
            ref="CalendarModal"
        >
            <template slot="body" slot-scope="body">
                <div class="container-fluid">

                    <!-- Event Mode Selection (Only for New Events) -->
                    <div class="form-group row align-items-center" v-if="isNewEvent">
                        <label for="" class="col-sm-3 col-form-label">
                            {{ trans[locale]['datetimeLang']['event_mode'] || '事項模式' }}
                        </label>
                        <div class="col-sm-9">
                            <div class="form-check form-check-inline">
                                <label class="custom-radio">
                                    <input type="radio" v-model="event_mode" value="single">
                                    <span class="radiomark"></span>
                                    {{ trans[locale]['datetimeLang']['single_event'] || '單一事項' }}
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <label class="custom-radio">
                                    <input type="radio" v-model="event_mode" value="multiple">
                                    <span class="radiomark"></span>
                                    {{ trans[locale]['datetimeLang']['multiple_events'] || '多次事項' }}
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Multi-date Picker (Only for Multiple Mode) -->
                    <div :class="error_msg['multiple_dates'] ? 'form-group row align-items-center has-error' : 'form-group row align-items-center'" v-if="isMultipleMode">
                        <label for="" class="col-sm-3 col-form-label">
                            {{ trans[locale]['datetimeLang']['multiple_dates'] }}
                        </label>
                        <div class="col-sm-9">
                            <multi-date-picker
                                v-model="modal_data['multiple_dates']"
                                :format="'yyyy-LL-dd'"
                                :week-start="7"
                                :locale="locale"
                                :button-text="trans[locale]['datetimeLang']['select_dates']"
                                :title="trans[locale]['datetimeLang']['select_dates']"
                                :placeholder="trans[locale]['datetimeLang']['select_multiple_dates']"
                                display-format="count"
                                value-zone="local"
                            >
                                <template slot="button-cancel">
                                    {{ trans[locale]['datetimeLang']['cancel'] }}
                                </template>
                                <template slot="button-confirm">
                                    {{ trans[locale]['datetimeLang']['confirm'] }}
                                </template>
                            </multi-date-picker>
                            <div class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['multiple_dates']">
                                {{ error_msg['multiple_dates'][0] }}
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['allDay']
                            }}</label>
                        <div class="col-sm-9">
                            <div class="form-check form-check-inline">
                                <label class="custom-cb">
                                    <input type="checkbox" v-model="modal_data['allDay']">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div :class="error_msg['start'] ? 'form-group row required has-error' : 'form-group row required'" v-if="isSingleMode">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['start']
                            }}</label>
                        <div class="col-sm-9">
                            <div class="form-control">
                                <datetime
                                    :input-id="'calendar_start_datetime' + side"
                                    ref="startDateTime"
                                    value-zone="local"
                                    :format="!modal_data['allDay'] ? 'yyyy-LL-dd HH:mm' : 'yyyy-LL-dd'"
                                    :type="!modal_data['allDay'] ? 'datetime' : 'date'"
                                    v-model="modal_data['start']"
                                    :week-start="7"
                                    :auto="true"
                                >
                                    <template slot="button-cancel" slot-scope="scope">
                                        {{ trans[locale]['datetimeLang']['cancel'] }}
                                    </template>
                                    <template slot="button-confirm" slot-scope="scope">
                                        {{ trans[locale]['datetimeLang']['confirm'] }}
                                    </template>
                                </datetime>
                            </div>
                            <div id="start_status"
                                 class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['start']"
                            >
                                {{ error_msg['start'][0] }}
                            </div>
                        </div>
                    </div>
                    <div :class="error_msg['end'] ? 'form-group row required has-error' : 'form-group row required'" v-if="isSingleMode">
                        <label for="" class="col-sm-3 col-form-label">{{ trans[locale]['datetimeLang']['end'] }}</label>
                        <div class="col-sm-9">
                            <div class="form-control">
                                <datetime
                                    :input-id="'calendar_end_datetime_' + side"
                                    ref="endDateTime"
                                    value-zone="local"
                                    :format="!modal_data['allDay'] ? 'yyyy-LL-dd HH:mm' : 'yyyy-LL-dd'"
                                    :type="!modal_data['allDay'] ? 'datetime' : 'date'"
                                    v-model="modal_data['end']"
                                    :week-start="7"
                                    :auto="true"
                                >
                                    <template slot="button-cancel" slot-scope="scope">
                                        {{ trans[locale]['datetimeLang']['cancel'] }}
                                    </template>
                                    <template slot="button-confirm" slot-scope="scope">
                                        {{ trans[locale]['datetimeLang']['confirm'] }}
                                    </template>
                                </datetime>
                            </div>
                            <div id="end_status"
                                 class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['end']"
                            >
                                {{ error_msg['end'][0] }}
                            </div>
                        </div>
                    </div>

                    <!-- Time pickers for multiple mode (when not all-day) -->
                    <div :class="error_msg['start_time'] ? 'form-group row required has-error' : 'form-group row'" v-if="isMultipleMode && !modal_data['allDay']">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['start_time']
                            }}</label>
                        <div class="col-sm-9">
                            <div class="form-control">
                                <datetime
                                    :input-id="'calendar_start_time_' + side"
                                    value-zone="local"
                                    format="HH:mm"
                                    type="time"
                                    v-model="start_time"
                                    :auto="true"
                                >
                                    <template slot="button-cancel" slot-scope="scope">
                                        {{ trans[locale]['datetimeLang']['cancel'] }}
                                    </template>
                                    <template slot="button-confirm" slot-scope="scope">
                                        {{ trans[locale]['datetimeLang']['confirm'] }}
                                    </template>
                                </datetime>
                            </div>
                            <div class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['start_time']">
                                {{ error_msg['start_time'][0] }}
                            </div>
                        </div>
                    </div>
                    <div :class="error_msg['end_time'] ? 'form-group row required has-error' : 'form-group row'" v-if="isMultipleMode && !modal_data['allDay']">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['end_time']
                            }}</label>
                        <div class="col-sm-9">
                            <div class="form-control">
                                <datetime
                                    :input-id="'calendar_end_time_' + side"
                                    value-zone="local"
                                    format="HH:mm"
                                    type="time"
                                    v-model="end_time"
                                    :auto="true"
                                >
                                    <template slot="button-cancel" slot-scope="scope">
                                        {{ trans[locale]['datetimeLang']['cancel'] }}
                                    </template>
                                    <template slot="button-confirm" slot-scope="scope">
                                        {{ trans[locale]['datetimeLang']['confirm'] }}
                                    </template>
                                </datetime>
                            </div>
                            <div class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['end_time']">
                                {{ error_msg['end_time'][0] }}
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['school_day']
                            }}</label>
                        <div class="col-sm-9">
                            <div class="form-check form-check-inline">
                                <label class="custom-cb">
                                    <input type="checkbox" v-model="modal_data['school_day']">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['non_chinese_speaking']
                            }}</label>
                        <div class="col-sm-9">
                            <div class="form-check form-check-inline">
                                <label class="custom-cb">
                                    <input type="checkbox" v-model="modal_data['non_chinese_speaking']">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div
                        :class="error_msg['en_title'] ? 'form-group row required has-error' : 'form-group row required'">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['en_title']
                            }}</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control "
                                   placeholder="" name="other_name" v-model="modal_data['en_title']">
                            <div id="en_title_status"
                                 class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['en_title']"
                            >
                                {{ error_msg['en_title'][0] }}
                            </div>
                        </div>
                    </div>

                    <div :class="error_msg['other_title'] ? 'form-group row required has-error' : 'form-group row'">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['other_title']
                            }}</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control "
                                   placeholder="" name="other_name" v-model="modal_data['other_title']">
                            <div id="other_title_status"
                                 class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['other_title']"
                            >
                                {{ error_msg['other_title'][0] }}
                            </div>
                        </div>
                    </div>

                    <div :class="error_msg['location'] ? 'form-group row required has-error' : 'form-group row'">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['location']
                            }}</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control "
                                   placeholder="" name="other_name" v-model="modal_data['location']">
                            <div id="location_status"
                                 class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['location']"
                            >
                                {{ error_msg['location'][0] }}
                            </div>
                        </div>
                    </div>

                    <div :class="error_msg['type'] ? 'form-group row required has-error' : 'form-group row required'">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['type']
                            }}</label>
                        <div class="col-sm-9">
                            <multiselect
                                :options="event_type"
                                v-model="modal_data['type']"
                                track-by="key"
                                label="name"
                                :searchable="false"
                                :allow-empty="false"
                                :close-on-select="true"
                                :show-labels="false"
                            >
                            </multiselect>
                            <div id="type_status"
                                 class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['type']"
                            >
                                {{ error_msg['type'][0] }}
                            </div>
                        </div>
                    </div>

                    <div
                        :class="error_msg['assign_to'] ? 'form-group row required has-error' : 'form-group row required'"
                        v-if="modal_data['type']['key'] == 'holiday' || modal_data['type']['key'] == 'school-event' || modal_data['type']['key'] == 'class-suspensions' || modal_data['type']['key'] == 'face-to-face-classes-suspension'">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['assign_to']
                            }}</label>
                        <div class="col-sm-9">
                            <div class="form-check form-check-inline">
                                <label class="custom-cb">
                                    <input type="radio"
                                           v-model="modal_data['assign_to']"
                                           value="section"
                                    >
                                    <span class="checkmark"></span> {{ trans[locale]['datetimeLang']['day_type'] }}
                                </label>
                            </div>

                            <div class="form-check form-check-inline">
                                <label class="custom-cb">
                                    <input type="radio"
                                           v-model="modal_data['assign_to']"
                                           value="level"
                                    >
                                    <span class="checkmark"></span> {{ trans[locale]['datetimeLang']['level'] }}
                                </label>
                            </div>

                            <div class="form-check form-check-inline">
                                <label class="custom-cb">
                                    <input type="radio"
                                           v-model="modal_data['assign_to']"
                                           value="academic_class"
                                    >
                                    <span class="checkmark"></span> {{
                                        trans[locale]['datetimeLang']['academic_class']
                                    }}
                                </label>
                            </div>

                            <div id="assign_to_status"
                                 class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['assign_to']"
                            >
                                {{ error_msg['assign_to'][0] }}
                            </div>
                        </div>
                    </div>

                    <div :class="error_msg['section'] ? 'form-group row required has-error' : 'form-group row required'"
                         v-if="modal_data['assign_to'] == 'section'">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['section']
                            }}</label>
                        <div class="col-sm-9">
                            <multiselect
                                :options="section_options"
                                v-model="modal_data['day_type']"
                                track-by="key"
                                label="name"
                                :searchable="false"
                                :allow-empty="true"
                                :close-on-select="false"
                                :show-labels="false"
                                :multiple="true"
                                group-values="libs"
                                group-label="language"
                                :group-select="true"
                                :placeholder="trans[locale]['datetimeLang']['day_type']"
                            >
                            </multiselect>
                            <div id="day_type_status"
                                 class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['section']"
                            >
                                {{ error_msg['section'][0] }}
                            </div>
                        </div>
                    </div>


                    <div :class="error_msg['level'] ? 'form-group row required has-error' : 'form-group row required'"
                         v-if="modal_data['assign_to'] == 'level'">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['level']
                            }}</label>
                        <div class="col-sm-9">
                            <multiselect
                                :options="level_options"
                                v-model="modal_data['level']"
                                track-by="key"
                                label="name"
                                :searchable="false"
                                :allow-empty="true"
                                :close-on-select="false"
                                :show-labels="false"
                                :multiple="true"
                                group-values="libs"
                                group-label="language"
                                :group-select="true"
                                :placeholder="trans[locale]['datetimeLang']['level']"

                            >
                            </multiselect>
                            <div id="level_status"
                                 class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['level']"
                            >
                                {{ error_msg['level'][0] }}
                            </div>
                        </div>
                    </div>

                    <div
                        :class="error_msg['academic_class'] ? 'form-group row required has-error' : 'form-group row required'"
                        v-if="modal_data['assign_to'] == 'academic_class'">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['academic_class']
                            }}</label>
                        <div class="col-sm-9">
                            <multiselect
                                :options="class_options"
                                v-model="modal_data['academic_class']"
                                track-by="key"
                                label="name"
                                :searchable="false"
                                :allow-empty="true"
                                :close-on-select="false"
                                :show-labels="false"
                                :multiple="true"
                                :placeholder="trans[locale]['datetimeLang']['academic_class']"
                            >
                            </multiselect>
                            <div id="academic_class_status"
                                 class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['academic_class']"
                            >
                                {{ error_msg['academic_class'][0] }}
                            </div>
                            <b-alert show
                                     class="small-txt mt-1 mb-1"
                                     v-if="class_event_msg != null"
                            ><i class="fas fa-exclamation-circle"></i>{{ class_event_msg }}
                            </b-alert>
                        </div>
                    </div>

                    <div
                        :class="error_msg['student_name'] ? 'form-group row required has-error' : 'form-group row required'"
                        v-if="modal_data['assign_to'] == 'student_name'">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['student_name']
                            }}</label>
                        <div class="col-sm-9">
                            <multiselect
                                :options="student_name_options"
                                v-model="modal_data['student_name']"
                                track-by="key"
                                label="name"
                                :searchable="false"
                                :allow-empty="true"
                                :close-on-select="false"
                                :show-labels="false"
                                :multiple="false"
                                group-values="libs"
                                group-label="language"
                                :group-select="true"
                                :placeholder="trans[locale]['datetimeLang']['student_name']"
                            >
                            </multiselect>
                            <div id="student_name_status"
                                 class="invalid-feedback"
                                 style="display:block !important;"
                                 v-cloak
                                 v-if="error_msg['student_name']"
                            >
                                {{ error_msg['student_name'][0] }}
                            </div>
                        </div>
                    </div>

                    <div :class="error_msg['en_description'] ? 'form-group row has-error' : 'form-group row'">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['en_description']
                            }}</label>
                        <div class="col-sm-9">
                            <textarea class="form-control" rows="5"
                                      name="en_description"
                                      id="en_description"
                                      aria-describedby="en_description_status"
                                      v-model="modal_data['en_description']"
                            >
                            </textarea>
                        </div>
                    </div>

                    <div :class="error_msg['other_description'] ? 'form-group row has-error' : 'form-group row'">
                        <label for="" class="col-sm-3 col-form-label">{{
                                trans[locale]['datetimeLang']['other_description']
                            }}</label>
                        <div class="col-sm-9">
                            <textarea class="form-control" rows="5"
                                      name="other_description"
                                      id="other_description"
                                      aria-describedby="other_description_status"
                                      v-model="modal_data['other_description']"
                            >
                            </textarea>
                        </div>
                    </div>

                    <div v-if="false">  <!--if useful, use later-->
                        <div class="form-group row required">
                            <label for="" class="col-sm-3 col-form-label">{{
                                    trans[locale]['datetimeLang']['customColor']
                                }}</label>
                            <div class="col-sm-9">
                                <div class="form-check form-check-inline">
                                    <label class="custom-cb">
                                        <input type="checkbox" v-model="custom_color">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row required" v-show="custom_color">
                            <label for="" class="col-sm-3 col-form-label">{{
                                    trans[locale]['datetimeLang']['color']
                                }}</label>
                            <div class="col-sm-9">
                                <sketch-picker v-model="modal_data['color']"/>
                            </div>
                        </div>
                        <div class="form-group row required" v-show="custom_color">
                            <label for="" class="col-sm-3 col-form-label">{{
                                    trans[locale]['datetimeLang']['textColor']
                                }}</label>
                            <div class="col-sm-9">
                                <sketch-picker v-model="modal_data['textColor']"/>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template slot="footer" slot-scope="footer">
                <div class="modal-footer">
                    <button type="button" class="btn btn-white" data-dismiss="modal" @click="refresh">
                        {{ trans[locale]['datetimeLang']['cancel'] }}
                    </button>
                    <button type="button" class="btn btn-red" @click="remove">
                        {{ trans[locale]['datetimeLang']['delete'] }}
                    </button>
                    <button type="button" class="btn btn-blue" @click="submit">
                        {{ trans[locale]['datetimeLang']['submit'] }}
                    </button>
                </div>
            </template>
        </modal>
    </div>
</template>
<script>
import {FullCalendar} from 'vue-full-calendar'
import 'fullcalendar/dist/fullcalendar.css'
import {Swatches, Sketch} from 'vue-color'
import {Datetime} from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import {helperCommon} from "../../mixins/helper.common";

export default {
    mixins: [helperCommon],
    components: {
        FullCalendar,
        'swatches-picker': Swatches,
        'sketch-picker': Sketch,
        Datetime,
    },
    props: {
        editable: {
            type: Boolean,
            default: false,
        },
        event_type: {
            type: Array
        },
        day_type: {
            type: Array
        },
        level: {
            type: Array
        },
        side: {
            type: String
        },
        class_option_url: {
            required: false,
            type: String,
            default: null,
        },
        class_event_msg: {
            required: false,
            type: String,
            default: null,
        }
    },
    computed: {
        events() {
            let result = [];
            _.each(this.raw_events, (event) => {
                let e = {
                    'id': event.id,
                    'title': event.title,
                    'en_title': event.en_title,
                    'other_title': event.other_title,
                    'location': event.location,
                    'en_description': event.en_description,
                    'other_description': event.other_description,
                    'allDay': (this.month_view) ? true : event.allDay,
                    'original_allDay': event.allDay,
                    'school_day': event.school_day,
                    'start': event.start,
                    'end': event.end,
                    'original_start': event.start,
                    'original_end': event.original_end,
                    'allday_end': event.allday_end,
                    'type': event.type,
                    'day_type': event.day_type,
                    'level': event.level,
                    'academic_class': event.academic_class,
                    'assign_to': event.assign_to,
                    'color': event.color,
                    'textColor': event.textColor,
                    'editable': event.editable,
                    'className': event.className,
                    'non_chinese_speaking': event.non_chinese_speaking,
                };
                if (e.allDay) {
                    if (e.allday_end) {
                        e.end = e.allday_end;
                    }
                }

                if (this.side == 'right') {
                    e.editable = false;
                    e.className = '';
                }

                result.push(e);
            })

            return result;
        },
        section_options() {
            return [
                {
                    language: this.trans[this.locale]['selectionLang']['select_all'],
                    libs: this.day_type,
                }
            ];
        },
        level_options() {
            return [
                {
                    language: this.trans[this.locale]['selectionLang']['select_all'],
                    libs: this.level,
                }
            ];
        },
        assign_to_options() {
            return [
                {key: 'section', name: this.trans[this.locale]['datetimeLang']['day_type']},
                {key: 'level', name: this.trans[this.locale]['datetimeLang']['level']},
                {key: 'academic_class', name: this.trans[this.locale]['datetimeLang']['academic_class']}
            ];
        },
        fetch_class_url() {
            if (!this.class_option_url) return null;
            // In multiple mode there is no single start date; use base URL only
            if (this.isMultipleMode) return this.class_option_url;
            if (_.isNull(this.modal_data.start) || this.modal_data.start === '') return this.class_option_url;
            const startMoment = moment(this.modal_data.start);
            if (!startMoment.isValid()) return this.class_option_url;
            return this.class_option_url + '/' + startMoment.format('YYYY-MM-DD');
        },

        isNewEvent() {
            return !this.modal_data.id || this.modal_data.id.toString().startsWith('new');
        },

        isSingleMode() {
            return this.event_mode === 'single';
        },

        isMultipleMode() {
            return this.event_mode === 'multiple';
        }
    },
    watch: {
        search_day_type() {
            this.refresh();
        },
        search_level() {
            this.refresh();
        },
        search_student_info() {
            this.refresh();
        },
        modal_data: {
            handler(val) {
                if (val.end == '') {
                    this.modal_data.end = val.start;
                } else {
                    if (val.end < val.start) {
                        this.modal_data.end = val.start;
                    }
                }

                if (val.type && val.type.key && (val.type.key == 'public-holiday' || val.type.key == 'internal-event')) {
                    this.modal_data.assign_to = '';
                }
            },
            deep: true,
        },
        fetch_class_url() {
            this.fetchClassOptions();
        },
        event_mode(newMode) {
            // Clear date-related fields when switching modes
            if (newMode === 'single') {
                this.modal_data.multiple_dates = [];
                this.start_time = '';
                this.end_time = '';
            } else if (newMode === 'multiple') {
                this.modal_data.start = '';
                this.modal_data.end = '';
            }
        },
        'modal_data.allDay'(isAllDay) {
            // Clear time values when switching to all-day mode
            if (isAllDay) {
                this.start_time = '';
                this.end_time = '';
            }
        }
    },
    data() {
        return {
            locale: window.locale,
            custom_color: false,
            keyword: '',
            search_day_type: '',
            search_level: '',
            search_academic_class: '',
            search_assign_to: '',
            search_student_info: '',
            section_level: '',
            section_academic_class: '',
            class_options: [],
            config: {
                locale: window.locale == 'en' ? 'en' : 'zh-tw',
                defaultView: 'month',
                header: {
                    left: 'title',
                    center: '',
                    right: 'prev,next,agendaWeek,agendaDay,month,listMonth',
                },
                views: {
                    timeGridFourDay: {
                        type: 'timeGrid',
                        duration: {days: 4}
                    },
                },
                buttonText: {},
                allDayText: '',
                displayEventEnd: false,
                // editable : false,
            },
            month_view: false,
            raw_events: [],
            selected_day: '',
            modal_data: {
                allDay: false,
                school_day: false,
                id: '',
                type: {},
                day_type: null,
                level: null,
                academic_class: null,
                start: '',
                end: '',
                title: '',
                location: '',
                color: '',
                textColor: '',
                className: [],
                description: '',
                assign_to: '',
                non_chinese_speaking: false,
                multiple_dates: [],
            },
            error_msg: {},
            event_mode: 'single', // 'single' or 'multiple'
            start_time: '',
            end_time: '',
        }
    },
    beforeMount() {
        this.config.buttonText = this.trans[this.locale]['datetimeLang']['buttonText'];
        this.config.allDayText = this.trans[this.locale]['datetimeLang']['allDayText'];
        this.config.noEventsMessage = this.trans[this.locale]['datetimeLang']['no_event_message'];
        this.modal_data['editable'] = this.editable;
        if (this.side == 'left') {
            this.month_view = true;
            this.config.header = {
                left: '',
                center: '',
                right: '',
            };
            this.config.defaultView = 'month';
        } else {
            this.config.header = {
                left: '',
                center: '',
                right: '',
            };
            this.config.defaultView = 'list';
            this.config.duration = {years: 2}
        }
    },
    methods: {
        getEvents(year, month) {
            // this.$store.commit('setSubmitting', true);
            //
            // let section_ids = [];
            // let level_ids = [];
            // if(this.search_day_type) {
            //     _.each(this.search_day_type, (item) => {
            //         section_ids.push(item.key);
            //     });
            // }
            // if(this.search_day_type) {
            //     _.each(this.search_level, (item) => {
            //         level_ids.push(item.key);
            //     });
            // }
            //
            // console.log(section_ids, level_ids);
            //
            // if(this.search_day_type) {
            //
            // }
            // axios.get('/school-management/school-calendar/calendar/list', {params : {year : year, month : month, keyword: this.keyword, section_ids : section_ids, level_ids: level_ids}})
            //     .then(response => {
            //         this.$store.commit('setSubmitting', false);
            //         this.raw_events = response.data;
            //     });
        },
        setEvents(data) {
            this.raw_events = data;
        },
        click: function (event) {
            if (this.editable) {
                this.clear();
                this.selected_day = event.format('YYYY-MM-DD[T]HH:mm:ss');
                this.modal_data['start'] = this.selected_day;
                this.modal_data['id'] = 'new_' + event.format('hms');
                this.modal_data['type'] = {};
                this.modal_data['day_type'] = null;
                this.modal_data['level'] = null;
                this.modal_data['academic_class'] = null;
                this.modal_data['assign_to'] = null;

                this.error_msg = {};
                this.$store.commit('clearNotification');
                this.$store.commit('clearValidationError');
                this.$store.commit('clearError');

                this.$refs.CalendarModal.toggle();
            }
        },
        edit: function (event) {
            if (this.editable) {
                this.modal_data = {
                    id: event.id,
                    start: (event.original_start).replace(' ', 'T'),
                    end: (event.original_allDay) ? event.end.subtract(1, 'day').format('YYYY-MM-DD[T]HH:mm:ss') : (event.original_end).replace(' ', 'T'),
                    en_title: event.en_title,
                    other_title: event.other_title,
                    location: event.location,
                    color: event.color,
                    textColor: event.textColor,
                    className: event.className,
                    event_id: event._id,
                    allDay: event.original_allDay,
                    school_day: event.school_day,
                    non_chinese_speaking: event.non_chinese_speaking,
                    en_description: event.en_description,
                    other_description: event.other_description,
                    type: event.type,
                    day_type: event.day_type,
                    level: event.level,
                    academic_class: event.academic_class,
                    assign_to: event.day_type.length > 0 ?
                        'section' :
                        (
                            event.level.length > 0 ?
                                'level' :
                                (
                                    event.academic_class.length > 0 ?
                                        'academic_class' :
                                        ''
                                )
                        ),
                };

                this.error_msg = {};
                this.$store.commit('clearNotification');
                this.$store.commit('clearValidationError');
                this.$store.commit('clearError');

                this.$refs.CalendarModal.toggle();
            }
        },
        drop: function (event) {
            if (this.editable) {
                this.modal_data = {
                    id: event.id,
                    start: (event.start).format('YYYY-MM-DD[T]HH:mm:ss'),
                    end: event.end.subtract(1, 'day').format('YYYY-MM-DD[T]HH:mm:ss'),
                    en_title: event.en_title,
                    other_title: event.other_title,
                    location: event.location,
                    color: event.color,
                    textColor: event.textColor,
                    className: event.className,
                    event_id: event._id,
                    allDay: event.original_allDay,
                    school_day: event.school_day,
                    non_chinese_speaking: event.non_chinese_speaking,
                    en_description: event.en_description,
                    other_description: event.other_description,
                    type: event.type,
                    day_type: event.day_type,
                    level: event.level,
                    academic_class: event.academic_class,
                    assign_to: event.day_type.length > 0 ? 'section' : (event.level != null ? 'level' : ''),
                };

                this.error_msg = {};
                this.$store.commit('clearNotification');
                this.$store.commit('clearValidationError');
                this.$store.commit('clearError');

                this.$refs.CalendarModal.toggle();
            }
        },
        next: function (event) {
            this.$refs.calendar.fireMethod('next')
        },
        prev() {
            this.$refs.calendar.fireMethod('prev')
        },
        today() {
            this.$refs.calendar.fireMethod('today');
        },
        view(view) {
            if (view == 'month') {
                this.month_view = true;
            } else {
                this.month_view = false;
            }
            this.$refs.calendar.fireMethod('changeView', view)
        },
        gotoDate(date) {
            this.$refs.calendar.fireMethod('gotoDate', date)
        },
        refresh() {
            this.$store.commit('clearNotification');
            this.$store.commit('clearValidationError');
            this.$store.commit('clearError');
            window.eventHub.$emit('fetch-events');
        },
        getViewYear() {
            let view = this.$refs.calendar.fireMethod('getView');
            return view.intervalStart.format('YYYY');
        },
        getViewMonth() {
            let view = this.$refs.calendar.fireMethod('getView');
            return view.intervalStart.format('MM');
        },
        getViewYearMonth() {
            let view = this.$refs.calendar.fireMethod('getView');
            return view.intervalStart.format('YYYY-MM');
        },
        submit(toggle = true) {
            this.error_msg = {};
            this.$store.commit('clearNotification');
            this.$store.commit('clearValidationError');
            this.$store.commit('clearError');
            this.$store.commit('setSubmitting', true);

            // Check if multiple mode
            if (this.isMultipleMode) {
                this.submitMultipleEvents(toggle);
                return;
            }

            // Single mode - existing logic
            // // for customer color picker
            // if(typeof this.modal_data.color === 'object') {
            //     this.modal_data.color = this.modal_data.color.hex;
            //     this.modal_data.textColor = this.modal_data.textColor.hex;
            // }

            let formData = {
                id: this.modal_data['id'],
                start: _.isNull(this.modal_data['start']) ?
                    null :
                    (this.modal_data.allDay ?
                        this._dateFormatHandle(this.modal_data['start'], 'YYYY-MM-DD') :
                        this._dateFormatHandle(this.modal_data['start'], 'YYYY-MM-DD HH:mm:ss')),
                end: _.isNull(this.modal_data['end']) ?
                    null :
                    (this.modal_data.allDay ?
                        this._dateFormatHandle(this.modal_data['end'], 'YYYY-MM-DD') :
                        this._dateFormatHandle(this.modal_data['end'], 'YYYY-MM-DD HH:mm:ss')),
                en_title: this.modal_data['en_title'],
                other_title: this.modal_data['other_title'],
                location: this.modal_data['location'],
                color: this.modal_data['color'],
                textColor: this.modal_data['textColor'],
                className: this.modal_data['className'],
                event_id: this.modal_data['event_id'],
                allDay: this.modal_data['allDay'],
                school_day: this.modal_data['school_day'],
                non_chinese_speaking: this.modal_data['non_chinese_speaking'],
                en_description: this.modal_data['en_description'],
                other_description: this.modal_data['other_description'],
                type: this.modal_data['type'],
                section: this.modal_data['day_type'],
                level: this.modal_data['level'],
                academic_class: this.modal_data['academic_class'],
                assign_to: this.modal_data['assign_to'],
            }

            formData['all_day'] = this.modal_data.allDay;

            if (this.modal_data['type']) {
                formData['type'] = this.modal_data['type'].key;
            }

            this.$store.commit('setSubmitting', true);
            let ajaxSuccessCallback = (response) => {
                // this.getEvents(this.getViewYear(), this.getViewMonth());
                window.eventHub.$emit('fetch-events');
                this.clear(toggle);

                this.$store.commit('setNotification', response.data.msg);
                this.$store.commit('setNotificationType', 'success');

            };
            let ajaxFailCallback = (error) => {
                this.$store.commit('setSubmitting', false);
                if (error.response.status == '422') {
                    this.error_msg = error.response.data.errors;
                }
            };

            let url = '/school-management/school-calendar/calendar/' + this.modal_data.id;
            this.$root.ajax_call(url, 'patch', formData, ajaxSuccessCallback, ajaxFailCallback, true);

            // if(this.modal_data.id) {
            //     this.removeEvent(this.modal_data.id);
            //     if(this.modal_data.allDay && this.modal_data.end ) {
            //         // for fullcalendar last day excluded issue
            //         this.modal_data.end = moment(this.modal_data.end).add(1, 'day');
            //     }
            //     this.raw_events.push(this.modal_data);
            // }
        },
        submitMultipleEvents(toggle = true) {
            // Validate multiple dates
            if (!this.validateMultipleDates()) {
                this.$store.commit('setSubmitting', false);
                return;
            }

            let events = this.buildEventsArray();
            let formData = { sequence_submits: events };
            let url = '/school-management/school-calendar/calendar/batch-create';

            let ajaxSuccessCallback = (response) => {
                // API returns { msg: [ { index, status, error_msg? }, ... ] }
                let results = (response.data && response.data.msg) ? response.data.msg : (response.data || []);
                if (!Array.isArray(results)) results = [];
                let done_users = results.filter(r => r.status);
                let fail_users = results.filter(r => !r.status);
                let success_count = done_users.length;
                let fail_count = fail_users.length;

                if (success_count > 0) {
                    let createdTemplate = this.trans[this.locale]['datetimeLang']['created'] || ':count created';
                    let msg = createdTemplate.replace(':count', success_count);
                    this.$store.commit('setNotification', msg);
                    this.$store.commit('setNotificationType', 'success');
                }

                if (fail_count > 0) {
                    let failureLabel = this.trans[this.locale]['datetimeLang']['failure'] || 'Failed';
                    let error_msgs = fail_users.map(r => r.error_msg || failureLabel).join(', ');
                    this.$store.commit('setError', error_msgs);
                }

                window.eventHub.$emit('fetch-events');
                this.clear(toggle);
                this.$store.commit('setSubmitting', false);
            };

            let ajaxFailCallback = (error) => {
                this.$store.commit('setSubmitting', false);
                if (error.response && error.response.status === 422 && error.response.data && error.response.data.errors) {
                    this.error_msg = error.response.data.errors;
                } else if (error.response && error.response.data && error.response.data.msg) {
                    this.$store.commit('setError', error.response.data.msg);
                } else {
                    let failureLabel = this.trans[this.locale]['datetimeLang']['failure'] || this.trans[this.locale]['requestFailure'] || 'Request failed';
                    this.$store.commit('setError', failureLabel);
                }
            };

            this.$root.ajax_call(url, 'post', formData, ajaxSuccessCallback, ajaxFailCallback, true);
        },
        validateMultipleDates() {
            const msg = (key) => this.trans[this.locale]['datetimeLang'][key];
            // Clear previous multiple-mode field errors so we only show current failure
            this.$delete(this.error_msg, 'multiple_dates');
            this.$delete(this.error_msg, 'start_time');
            this.$delete(this.error_msg, 'end_time');

            // Check if dates are selected
            if (!this.modal_data.multiple_dates || this.modal_data.multiple_dates.length === 0) {
                this.$set(this.error_msg, 'multiple_dates', [msg('please_select_dates')]);
                return false;
            }

            // Check max 30 dates
            if (this.modal_data.multiple_dates.length > 30) {
                this.$set(this.error_msg, 'multiple_dates', [msg('max_30_dates')]);
                return false;
            }

            // Check for duplicate dates
            let unique_dates = [...new Set(this.modal_data.multiple_dates)];
            if (unique_dates.length !== this.modal_data.multiple_dates.length) {
                this.$set(this.error_msg, 'multiple_dates', [msg('duplicate_dates')]);
                return false;
            }

            // Validate time fields if not all-day
            if (!this.modal_data.allDay) {
                if (!this.start_time || !this.end_time) {
                    this.$set(this.error_msg, 'start_time', [msg('please_select_time')]);
                    this.$set(this.error_msg, 'end_time', [msg('please_select_time')]);
                    return false;
                }
                // Start time cannot be later than or equal to end time
                let startM = moment(this.start_time, ['HH:mm', 'HH:mm:ss', moment.ISO_8601]);
                let endM = moment(this.end_time, ['HH:mm', 'HH:mm:ss', moment.ISO_8601]);
                if (startM.isValid() && endM.isValid() && !startM.isBefore(endM)) {
                    this.$set(this.error_msg, 'end_time', [msg('start_cannot_be_later_than_end')]);
                    this.$set(this.error_msg, 'start_time', [msg('start_cannot_be_later_than_end')]);
                    return false;
                }
            }

            return true;
        },
        buildEventsArray() {
            let events = [];

            this.modal_data.multiple_dates.forEach((date, index) => {
                let start_datetime, end_datetime;

                if (this.modal_data.allDay) {
                    start_datetime = this._dateFormatHandle(date, 'YYYY-MM-DD');
                    end_datetime = this._dateFormatHandle(date, 'YYYY-MM-DD');
                } else {
                    // Merge date with time (start_time/end_time may be full ISO from vue-datetime, so format to HH:mm:ss)
                    let time_start = this._dateFormatHandle(this.start_time, 'HH:mm:ss');
                    let time_end = this._dateFormatHandle(this.end_time, 'HH:mm:ss');
                    start_datetime = this._dateFormatHandle(date, 'YYYY-MM-DD') + ' ' + (time_start || '00:00:00');
                    end_datetime = this._dateFormatHandle(date, 'YYYY-MM-DD') + ' ' + (time_end || '00:00:00');
                }

                let event = {
                    index: index,
                    start: start_datetime,
                    end: end_datetime,
                    en_title: this.modal_data['en_title'],
                    other_title: this.modal_data['other_title'],
                    location: this.modal_data['location'],
                    color: this.modal_data['color'],
                    textColor: this.modal_data['textColor'],
                    className: this.modal_data['className'],
                    event_id: this.modal_data['event_id'],
                    allDay: this.modal_data['allDay'],
                    all_day: this.modal_data['allDay'],
                    school_day: this.modal_data['school_day'],
                    non_chinese_speaking: this.modal_data['non_chinese_speaking'],
                    en_description: this.modal_data['en_description'],
                    other_description: this.modal_data['other_description'],
                    section: this.modal_data['day_type'],
                    level: this.modal_data['level'],
                    academic_class: this.modal_data['academic_class'],
                    assign_to: this.modal_data['assign_to'],
                };

                if (this.modal_data['type']) {
                    event['type'] = this.modal_data['type'].key;
                }

                events.push(event);
            });

            return events;
        },
        remove() {
            this.$store.commit('clearNotification');
            this.$store.commit('clearValidationError');
            this.$store.commit('clearError');
            this.$store.commit('setSubmitting', true);

            let ajaxSuccessCallback = (response) => {
                this.$store.commit('setSubmitting', false);
                this.$store.commit('setNotification', response.data.msg);
                this.$store.commit('setNotificationType', 'success');
            };

            let ajaxFailCallback = (error) => {
                this.$store.commit('setSubmitting', false);
                if (error.response.status == '422') {
                    this.$store.commit('setValidationError', error.response.data.errors)
                } else {
                    this.$store.commit('setSubmitting', false);
                }
            };

            let url = '/school-management/school-calendar/calendar/' + this.modal_data.id + '/delete';
            this.$root.ajax_call(url, 'delete', {}, ajaxSuccessCallback, ajaxFailCallback, true);

            this.removeEvent(this.modal_data.id);
            this.clear(true);
        },
        removeEvent(id) {
            let flag = false;
            _.each(this.raw_events, (item, index) => {

                if (item && item.id == id) {
                    this.raw_events.splice(index, 1);
                    flag = true;
                }
            });
            return flag;
        },
        clear(toggle = false) {
            if (this.$refs.endDateTime && typeof this.$refs.endDateTime.close === 'function') {
                this.$refs.endDateTime.close();
            }
            if (this.$refs.startDateTime && typeof this.$refs.startDateTime.close === 'function') {
                this.$refs.startDateTime.close();
            }
            this.modal_data = {
                id: '',
                start: '',
                end: '',
                en_title: '',
                other_title: '',
                location: '',
                //color : '',
                //textColor : '',
                className: [],
                allDay: false,
                school_day: false,
                non_chinese_speaking: false,
                en_description: '',
                other_description: '',
                type: {},
                day_type: null,
                level: null,
                academic_class: null,
                assign_to: null,
                multiple_dates: [],
                // url
                // className
                // editable
                // startEditable
                // durationEditable
                // resourceEditable
                // rendering
                // overlap
                // constraint
                // source
                // backgroundColor
                // borderColor
                // textColor
            };
            this.event_mode = 'single';
            this.start_time = '';
            this.end_time = '';
            this.custom_color = false;
            this.error_msg = {};
            if (toggle) {
                this.$store.commit('clearNotification');
                this.$store.commit('clearValidationError');
                this.$store.commit('clearError');
                this.$refs.CalendarModal.toggle();
            }
        },
        fetchClassOptions() {
            if (this.fetch_class_url) {
                let self = this;
                let url = this.fetch_class_url;
                self.$store.commit('setSubmitting', true);
                axios.get(url)
                    .then((response) => {
                        self.$nextTick(() => {
                            // update selection
                            self.class_options = response.data;
                            // refresh selected options
                            self.modal_data.academic_class = _.filter(self.modal_data.academic_class, function (o) {
                                return _.find(self.class_options, ['key', o.key]) !== undefined;
                            });
                            self.$store.commit('setSubmitting', false);
                        })
                    })
                    .catch((error) => {
                        self.class_options = [];
                        self.modal_data.academic_class = _.filter(self.modal_data.academic_class, function (o) {
                            return _.find(self.class_options, ['key', o.key]) !== undefined;
                        });
                        self.$store.commit('setSubmitting', false);
                    });
            }
        }
    }
}
</script>
<style>
/*a.fc-cus-notice:before {*/
/*content: '通告 :';*/
/*}*/
/*.fc-cus-notice {*/
/*background-color: #9be6f3 !important;*/
/*border-color: #0b2e13 !important;*/
/*}*/

.fc-cus-internal-event {
    background-color: #4286f4 !important;
    border-color: #4286f4 !important;
    color: #f2f2f2 !important;
}

.fc-cus-school-event {
    background-color: #017e8c !important;
    border-color: #017e8c !important;
    color: #f2f2f2 !important;
}

.fc-cus-holiday {
    background-color: #f49b42 !important;
    border-color: #f49b42 !important;
    color: #f2f2f2 !important;
}

.fc-cus-class-suspensions {
    background-color: #fc5203 !important;
    border-color: #fc5203 !important;
    color: #f2f2f2 !important;
}

.fc-cus-face-to-face-classes-suspension {
    background-color: #f067a3 !important;
    border-color: #f067a3 !important;
    color: #f2f2f2 !important;
}

.fc-cus-public-holiday {
    background-color: #ff4d4d !important;
    border-color: #ff4d4d !important;
    color: #f2f2f2 !important;
}

.vdatetime-popup__header {
    background: #0cafc2;
}

.vdatetime-popup__actions__button {
    color: #0cafc2;
}

.vdatetime-calendar__month__day--selected > span > span,
.vdatetime-calendar__month__day--selected:hover > span > span {
    color: #fff;
    background: #0cafc2;
}

.vdatetime-year-picker__item--selected {
    color: #0cafc2;
    font-size: 32px;
}

.vdatetime-time-picker__item--selected {
    color: #0cafc2;
    font-size: 32px;
}

.vdatetime-overlay {
    width: 100% !important;
    height: 100% !important;
    z-index: 999;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: white !important;
    transition: opacity .5s;
    opacity: 0.05;
}

.fc-scroller {
    height: 400px !important;
}

div.fc-toolbar {
    margin-bottom: 5px !important;
    height: 15px !important;
}

div.fc-scroller {
    overflow: scroll auto !important;
}

.dki-calendar-feature .vdatetime-popup {
    top: 12vh;
    -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
    width: 390px;
    max-height: calc(100vh - 12vh - 24px);
    overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Calendar/Calendar.vue